import React from "react";
import T from "prop-types";
import classNames from "classnames";

export default function Icon({ name, fixed = false }) {
  const classes = classNames(`fa fa-${name}`, {
    "fa-fw": fixed
  });

  return <i className={classes} />;
}

Icon.propTypes = { name: T.string.isRequired, fixed: T.bool };



// WEBPACK FOOTER //
// ./app/modules/shared/components/Icon/Icon.jsx